<template>
    <div class="kit-info__step--setting">
        <button @click="edit()">{{ !onEdit ? 'Edit' : 'Save' }}</button>
        <button @click="remove()">Remove</button>
    </div>
</template>

<script>
    export default {
        name: 'ProductSetting',
        props: ['step', 'pid'],
        data() {
            return {
                onEdit: false
            }
        },
        methods: {
            edit() {
                this.$emit('changeQuantity', !this.onEdit);

                this.onEdit = !this.onEdit;
            },
            
            remove() {
                const step = this.step;
                const pid = this.pid;
                
                this.$store.dispatch('removeFromCart', {step, pid});
            }
        }
    }
</script>

<style lang="scss">
    .kit {
        &-info {
            &__step {
                &--setting {
                    display: flex;
                    gap: 10px;

                    button {
                        color:#F97623;
                        text-decoration: underline;
                        font-size: 12px;
                        font-weight: 500;
                    }
                }
            }
        }
    }
</style>